import { useWorkspaceScope } from "../../../../shared/hooks/useWorkspaceScope";
import { useOrderConfirmationDraft } from "./useOrderConfirmationDraft";
import type { OrderConfirmationInput } from "../../domain/order-confirmation";
import { validOrderConfirmation } from "../../domain/order-confirmation";
import { useOrderConfirmationData } from "./useOrderConfirmationData";
import { useOrderConfirmationResponse } from "./useOrderConfirmationResponse";
const silent = () => { };
export function useOrderConfirmationWorkspace({ token }: { token: string; }) {
  const data = useOrderConfirmationData(token);
  const draftScope = useWorkspaceScope(`${token}:${data.workspace?.order.id ?? ""}`, silent);
  const draft = useOrderConfirmationDraft(draftScope);
  const {
    choice,
    reason,
    date,
    quantity,
    note
  } = draft;
  const input: OrderConfirmationInput = {
    responseType: choice, reason: reason.trim() || undefined,
    deliveryPlan: choice === "ACCEPTED" ? [{ date, quantity: Number(quantity), note: note.trim() || undefined }] : [], expectedVersion: data.workspace?.order.version ?? 0
  };
  const today = new Date().toISOString().slice(0, 10);
  const valid = Boolean(data.workspace && validOrderConfirmation(input, data.workspace.order.quantity, today));
  const response = useOrderConfirmationResponse({
    scope: data.scope,
    workspace: data.workspace,
    input,
    valid,
    invalidate: data.invalidate
  });
  const locked = response.submitting || response.uncertain;
  return {
    workspace: data.workspace,
    canRetryRead: data.canRetryRead,
    loading: data.loading && !response.done,
    error: response.error || data.error,
    load: () => { if (!locked) { response.clearError(); return data.load(); } },
    ...draft,
    today,
    valid,
    locked,
    submitting: response.submitting,
    done: response.done,
    uncertain: response.uncertain,
    submit: response.submit
  };
}
export type OrderConfirmationViewState = ReturnType<typeof useOrderConfirmationWorkspace>;
